import { atom } from "recoil"
import { HIGH_VIDEO_STREAM_TYPE } from "../../../constants"

export const MainVideoStreamTypeAtom = atom<number>({
  key: "MainVideoStreamTypeAtom",
  default: HIGH_VIDEO_STREAM_TYPE
})

export const UplinkStatusAtom = atom<number>({
  key: "UplinkStatusAtom",
  default: -1
})
